<template>
  <div>
    <div class="et-enterprise-title">
      <div class="et-enterprise-logo fl">
        <img src="http://www.cajay.net/images/logo.png" alt />
      </div>
      <div class="et-enterprise-name fl">
        <h1>
          广州凯捷物流供应链有限公司
        </h1>
        官方网站:<a href="www.cajay.net" target="_black">www.cajay.net</a>
      </div>
      <div class="et-enterprise-info fl">
        <i class="iconfont-small icon-account"></i>
        <span>5-10</span><br />
        <i class="iconfont-mini icon-phone"></i>
        <span>020-31216136</span><br />
        <i class="iconfont icon-location"></i>
        <span>广东省广州市白云区嘉禾街望岗上胜东街46号上胜创意园K栋101</span>
      </div>
      <div class="clear"></div>
    </div>
    <div class="et-channel-body">
      <el-tabs v-model="activename">
        <el-tab-pane label="渠道详情" name="channeldetails">
          <div class="et-channel-param">
            <div class="header">渠道参数</div>
            <table border="0" cellspacing="0" cellpadding="0" class="content">
              <tr>
                <td style="width:70px">渠道代码：</td>
                <td style="width:350px">{{channeldetails.channelcode}}</td>
                <td style="width:70px">渠道名称：</td>
                <td style="width:350px">{{channeldetails.channelname}}</td>
                <td style="width:70px">渠道分类：</td>
                <td style="width:350px">{{channeldetails.channeltype}}</td>
              </tr>
              <tr>
                <td>线路分类：</td>
                <td>{{channeldetails.channellinetype}}</td>
                <td>预计天数：</td>
                <td>{{channeldetails.estimatedstartday}}-{{channeldetails.estimatedEndday}}天</td>
                <td>体积基数：</td>
                <td>{{channeldetails.volumebasenum}}</td>
              </tr>
              <tr>
                <td>范围限制：</td>
                <td colspan="5">限重{{channeldetails.maxweight}}kg、限长{{channeldetails.maxlong}}cm、限积{{channeldetails.maxvolume}}m³</td>
              </tr>
              <tr>
                <td>详细介绍：</td>
                <td colspan="5" style="font-size:12px;color:#999999;">
                  {{channeldetails.channelsynopsis}}
                </td>
              </tr>
            </table>
          </div>
          <table border="0" cellspacing="0" cellpadding="0" class="et-channel-line-list-header">
            <tr>
              <th style="width:100px;">线路名</th>
              <th>派件范围</th>
              <th style="width:150px;">1KG参考价</th>
            </tr>
          </table>
          <table border="0" cellspacing="0" cellpadding="0" class="et-channel-line-list" v-for="(item,index) in channeldetails.channellinelist" :key="index">
            <tr @click="channellineClick(item)">
              <td style="width:100px;">{{item.channellinename}}</td>
              <td>
                <el-tag size="mini" v-for="(purpose,i) in item.purposelist" :key="i">{{purpose.label}}</el-tag>
              </td>
              <td style="width:150px;">{{item.totalfee}}</td>
            </tr>
            <tr v-show="item.showstate">
              <td colspan="3">
                <table border="0" cellspacing="0" cellpadding="0" style="width:100%;">
                  <tr v-for="(fee,i) in item.FeesList" :key="i" style="line-height:30px;">
                    <td style="border-top:1px solid #f2f2f2;">{{fee.PriceType}}</td>
                    <td style="border-top:1px solid #f2f2f2;">计费值：{{fee.BillingValue}}</td>
                    <td style="border-top:1px solid #f2f2f2;">标准价：{{fee.StandardPrice}}</td>
                    <td style="border-top:1px solid #f2f2f2;">折后价：{{fee.DiscountPrice}}</td>
                    <td style="border-top:1px solid #f2f2f2;">{{fee.FormulaString}}</td>
                    <td style="border-top:1px solid #f2f2f2;">{{fee.FormulaNote}}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
          <table border="0" cellspacing="0" cellpadding="0" style="width:100%;padding-top:20px;">
            <tr>
              <td>揽收范围：</td>
            </tr>
            <tr>
              <td>
                <el-tag v-for="(item,index) in channeldetails.shipmentlist" :key="index">{{item.label}}</el-tag>

                <el-tag size="mini" v-if="channeldetails.shipmentlist.length===0">全国</el-tag>
              </td>
            </tr>
          </table>
        </el-tab-pane>
        <el-tab-pane label="渠道评价" name="channelscore">
          <div class="et-enterprise-score">
            <div class="score-title">
              <span class="fl">综合评分：</span>
              <span class="score-title-data">{{scoreAvg()}}</span>
            </div>
            <ul class="et-enterprise-score-list fl">
              <li v-for="(item,index) in channelscorelist" :key="index" @mouseover="scoreMouseover(item)">
                <span>{{item.scorelabel}}：</span><span class="et-enterprise-score-list-data">{{item.score}}</span>
              </li>
            </ul>
            <table border="0" cellspacing="0" cellpadding="0" class="et-enterprise-score-details fl">
              <tr>
                <td style="width:200px;">
                  <el-rate v-bind="5" v-model="channelscoredetails.score" disabled show-score></el-rate>
                </td>
                <td>
                  共{{channelscoredetails.total}}人打分
                </td>
              </tr>
              <tr>
                <td>
                  <el-rate v-model="five" disabled show-score class="score-details"></el-rate>
                </td>
                <td>
                  <el-progress :percentage="Number(channelscoredetails.five/channelscoredetails.total*100).toFixed(2)" color="rgb(247, 186, 42)"></el-progress>
                </td>
              </tr>
              <tr>
                <td>
                  <el-rate v-model="four" disabled show-score class="score-details"></el-rate>
                </td>
                <td>
                  <el-progress :percentage="Number(channelscoredetails.four/channelscoredetails.total*100).toFixed(2)" color="rgb(247, 186, 42)"></el-progress>
                </td>
              </tr>
              <tr>
                <td>
                  <el-rate v-model="three" disabled show-score class="score-details"></el-rate>
                </td>
                <td>
                  <el-progress :percentage="Number(channelscoredetails.three/channelscoredetails.total*100).toFixed(2)" color="rgb(247, 186, 42)"></el-progress>
                </td>
              </tr>
              <tr>
                <td>
                  <el-rate v-model="two" disabled show-score class="score-details"></el-rate>
                </td>
                <td>
                  <el-progress :percentage="Number(channelscoredetails.two/channelscoredetails.total*100).toFixed(2)" color="rgb(247, 186, 42)"></el-progress>
                </td>
              </tr>
              <tr>
                <td>
                  <el-rate v-model="one" disabled show-score class="score-details"></el-rate>
                </td>
                <td>
                  <el-progress :percentage="Number(channelscoredetails.one/channelscoredetails.total*100).toFixed(2)" color="rgb(247, 186, 42)"></el-progress>
                </td>
              </tr>
            </table>
          </div>
          <div class="clear"></div>
          <div class="et-enterprise-levaluate" v-if="channelevaluatelist.length > 0">
            <table border="0" cellspacing="0" cellpadding="0" style="width:100%;marign-top:20px;font-size:12px;" class="et-enterprise-levaluate-list">
              <tr v-for="(item,index) in channelevaluatelist" :key="index">
                <td style="width:70%;font-size:12px;padding-left:10px;">
                  {{item.evaluate}}
                </td>
                <td style="width:15%; text-align:center;color:#999999;">
                  {{item.purpose}}
                </td>
                <td style="text-align:center;">
                  {{item.account}}
                </td>
              </tr>
            </table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activename: 'channeldetails',
      one: 1,
      two: 2,
      three: 3,
      four: 4,
      five: 5,
      channelscorelist: [
        {
          score: 4.5,
          scorelabel: '服务评分',
          one: 0,
          two: 2,
          three: 5,
          four: 10,
          five: 25
        },
        {
          score: 4,
          scorelabel: '价格评分',
          one: 6,
          two: 13,
          three: 9,
          four: 15,
          five: 13
        },
        {
          score: 4.3,
          scorelabel: '时效评分',
          one: 4,
          two: 3,
          three: 13,
          four: 20,
          five: 33
        },
        {
          score: 4.8,
          scorelabel: '质量评分',
          one: 1,
          two: 2,
          three: 5,
          four: 10,
          five: 25
        }
      ],
      channelscoredetails: {
        score: 0,
        scorelabel: '',
        one: 0,
        two: 0,
        three: 0,
        four: 0,
        five: 0,
        total: 0
      },
      channelevaluatelist: [
        {
          evaluate: '有时候涂口红或者唇膏以后喝水特别不方便，老是会沾到杯子上，所以就想买个吸管，再三斟酌之下，在一次性和不锈钢之间还是选择了不锈钢的吸管，送了洗吸管的小刷子还蛮贴心的，弯管的不是很好洗，我洗完之后就弯掉了小刷子，但是确实蛮好用的，如果能配上一个颜值高的杯子就更好看了',
          purpose: '美国',
          account: '广州康美森'
        }
      ],
      channeldetails: {
        channelcode: '001',
        channelname: '广州挂号小包',
        channeltype: '小包',
        channellinetype: '地区',
        estimatedstartday: 15,
        estimatedEndday: 30,
        maxweight: 2,
        maxlong: 150,
        maxvolume: 2,
        volumebasenum: 5000,
        channelsynopsis: '单边不超60，不计泡！EMS不接单边长度超1.5M货物，不同国家限制不一样，请单独咨询！！5KG以内（不含5KG）仿牌，国内扣关赔偿40元/KG，加退运费，5KG以上仿牌国内扣关只退运费不赔偿，国外被扣没有赔偿，不退运费！货物没出口前丢失，赔偿40元/KG+退运费，国外丢件邮局不做赔偿，不退运费！国际快递需要提供货物的英文品名，数量，还有申报价值用来清关用EMS快件国外退回没有退件费，免费退回可以纸箱包装，也可以包裹袋包装，易碎品请自行包装好，货物出现破损，邮局不赔偿！我司专业从事国际快递服务、还集成了各种发货方式（小包、大包  EMS、DHL、UPS   FEDEX  新马泰专线），一站式  全方位、优价优质服务。(免费提供国内仓储，代打包服务)      专业  专注  更专心   只为提供最优质的国际货运服务，我们用心，客户放心！         欢迎咨询价格。',
        shipmentlist: [],
        channellinelist: [
          {
            channellinename: '一区',
            purposelist: [{ label: '美国', value: '0' }, { label: '英国', value: '1' }, { label: '加拿大', value: 2 }],
            totalfee: 55.56,
            showstate: false,
            FeesList: [
              {
                PriceType: '运费',
                BillingValue: 5.5,
                StandardPrice: 1500,
                DiscountPrice: 1000,
                FormulaString: '（5.5*200）*0.9',
                FormulaNote: '不足1KG按1KG计费'
              },
              {
                PriceType: '报关费',
                BillingValue: 5.5,
                StandardPrice: 500,
                DiscountPrice: 200,
                FormulaString: '',
                FormulaNote: ''
              }
            ],
          },
          {
            channellinename: '一区',
            purposelist: [{ label: '美国', value: '0' }, { label: '英国', value: '1' }, { label: '加拿大', value: 2 }],
            totalfee: 55.56,
            showstate: false,
            FeesList: [
              {
                PriceType: '运费',
                BillingValue: 5.5,
                StandardPrice: 1500,
                DiscountPrice: 1000,
                FormulaString: '（5.5*200）*0.9',
                FormulaNote: '不足1KG按1KG计费'
              },
              {
                PriceType: '报关费',
                BillingValue: 5.5,
                StandardPrice: 500,
                DiscountPrice: 200,
                FormulaString: '',
                FormulaNote: ''
              }
            ],
          },
          {
            channellinename: '一区',
            purposelist: [{ label: '美国', value: '0' }, { label: '英国', value: '1' }, { label: '加拿大', value: 2 }],
            totalfee: 55.56,
            showstate: false,
            FeesList: [
              {
                PriceType: '运费',
                BillingValue: 5.5,
                StandardPrice: 1500,
                DiscountPrice: 1000,
                FormulaString: '（5.5*200）*0.9',
                FormulaNote: '不足1KG按1KG计费'
              },
              {
                PriceType: '报关费',
                BillingValue: 5.5,
                StandardPrice: 500,
                DiscountPrice: 200,
                FormulaString: '',
                FormulaNote: ''
              }
            ],
          },
          {
            channellinename: '一区',
            purposelist: [{ label: '美国', value: '0' }, { label: '英国', value: '1' }, { label: '加拿大', value: 2 }],
            totalfee: 55.56,
            showstate: false,
            FeesList: [
              {
                PriceType: '运费',
                BillingValue: 5.5,
                StandardPrice: 1500,
                DiscountPrice: 1000,
                FormulaString: '（5.5*200）*0.9',
                FormulaNote: '不足1KG按1KG计费'
              },
              {
                PriceType: '报关费',
                BillingValue: 5.5,
                StandardPrice: 500,
                DiscountPrice: 200,
                FormulaString: '',
                FormulaNote: ''
              }
            ],
          }
        ]
      }
    }
  },
  mounted () {
    if (this.channelscorelist.length > 0) {
      this.scoreMouseover(this.channelscorelist[0])
    }
  },
  methods: {
    channellineClick (item) {
      item.showstate = !item.showstate
    },
    scoreAvg () {
      var sumScore = 0
      this.channelscorelist.forEach((item, index) => {
        sumScore += item.score
      })
      return sumScore / this.channelscorelist.length
    },
    scoreMouseover (item) {
      this.channelscoredetails.score = item.score
      this.channelscoredetails.one = item.one
      this.channelscoredetails.two = item.two
      this.channelscoredetails.three = item.three
      this.channelscoredetails.four = item.four
      this.channelscoredetails.five = item.five
      this.channelscoredetails.total = item.one + item.two + item.three + item.four + item.five
    }
  }
}
</script>

<style>
.et-channel-body {
  width: 1280px;
  margin: 20px auto 20px auto;
  padding: 20px;
  background-color: #ffffff;
  min-height: 450px;
}

.et-channel-body .et-channel-param {
  width: 100%;
  line-height: 30px;
}

.et-channel-body .et-channel-param .header {
  background-color: #f2f2f2;
  font-size: 16px;
  padding-left: 10px;
}

.et-channel-body .et-channel-param .content {
  width: 100%;
  padding-left: 10px;
  line-height: 30px;
}

.et-channel-body .et-channel-param .label {
  width: 80px;
}

.et-channel-body .et-channel-param .param {
  width: 200px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.et-channel-body .et-channel-line-list-header {
  width: 100%;
  line-height: 30px;
  background-color: #f2f2f2;
}

.et-channel-body .et-channel-line-list {
  width: 100%;
  line-height: 30px;
  text-align: center;
}

.et-channel-body .et-channel-line-list {
  border: 1px solid #f2f2f2;
  border-top: 0;
}

.et-channel-body .et-channel-line-list:hover {
  background-color: #dffcff;
}

.et-channel-body .el-tag--mini {
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/channel.vue